import { ApprovalFlows } from '@mint-sdk/api-approval-flows';
import { z } from 'zod';

import { GroupStatuses } from '../constants/shared.js';

export const OptionItemSchema = z.object({
  label: z.string(),
  value: z.string(),
});
export type OptionItem = z.infer<typeof OptionItemSchema>;
export type EntityGroupType = OptionItem & {
  isCurrentUser: boolean;
  isRole: boolean;
};
export type LogicalRowType = {
  id: string;
  items: EntityGroupType[];
  status: GroupStatuses | null;
  resolvedAt: string | null;
  resolvedBy: string | null;
};
export type LogicalGroupType = LogicalRowType[];
export type ApprovalSequenceType = LogicalGroupType[];

export type EntitySpecificFields = Pick<
  ApprovalFlows.CreateRequestPayload,
  'entityId' | 'entityType' | 'entityName' | 'entitySource' | 'entityMetadata'
>;
export type { EntitySpecificFields as ApprovalStatusBarProps };

const ApproverEntitySchema = z.object({
  id: z.string(),
  label: z.string(),
  type: z.enum(['user', 'role', 'operation']),
});
export type ApproverEntity = z.infer<typeof ApproverEntitySchema>;

export const FlowStatusesEnum = z.enum([
  'active',
  'inactive',
  'scheduled',
  'ended',
]);
const FlowTypesEnum = z.enum(['flight']);

const ApproverItemLiteSchema = z.object({
  id: z.string(),
  name: z.string(),
  flowType: FlowTypesEnum,
  status: FlowStatusesEnum,
  inUse: z.boolean(),
  createdBy: z.string(),
  createdDate: z.string(),
  lastEditedBy: z.string(),
  lastEditedAt: z.string(),
  requesters: z.array(ApproverEntitySchema),
  approvers: z.array(ApproverEntitySchema),
  dateFrom: z.string(),
  dateTo: z.string().nullable(),
});

export type ApproverItemLite = z.infer<typeof ApproverItemLiteSchema>;
export type CheckFlowStatusData = NonNullable<
  ApprovalFlows.CheckFlowStatusResponse['data']
>['items'][number];
